module.exports = __webpack_public_path__ + "static/the-facebook-effect-081af3066f8cbafc7177c2b80ddf98e3.jpg";